var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-custom alert-white shadow-sm fade show mb-5",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-icon"},[_c('i',{class:_vm.icon})]),_c('div',{staticClass:"alert-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }